import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyC0HrprMAZjj1PrsqzJZUOGLTAouuVFWVA",
    authDomain: "furry-fort.firebaseapp.com",
    projectId: "furry-fort",
    storageBucket: "furry-fort.appspot.com",
    messagingSenderId: "127301591275",
    appId: "1:127301591275:web:1ffd93a32b2224c0c01eae",
    measurementId: "G-2TPMWDFGCE"
  };

  export const initializeAnalytics=()=>{
    const app = initializeApp(firebaseConfig);
    getAnalytics(app);
  }